<template>
  <v-container class="group-management" fluid>
    <div class="group-management-header">
      <h1 class="group-management-header__title">Собственники управляющих компаний</h1>
      <div class="group-management-header__actions">
        <v-btn
          v-if="$checkPermission('create_management_group')"
          color="primary"
          class="group-management-header__btn text-none"
          dark
          rounded
          @click.stop="createDialog = true"
        >
          <v-icon left>mdi-plus</v-icon>
          Новая компания
        </v-btn>
      </div>
    </div>

    <v-card class="group-management-block mt-3" flat outlined>
      <div class="group-management-filters">
        <div class="group-management-filters__title">
          <v-icon left small>mdi-filter-variant</v-icon>
          Фильтры
        </div>
        <div class="group-management-filters__row">
          <v-text-field
            v-model="filterName"
            @keyup.enter="filterCompanies"
            placeholder="Название"
            prepend-inner-icon="mdi-rename-box-outline"
            outlined
            dense
            hide-details
            class="group-management-filters__field"
          />
          <v-btn color="primary" class="text-none" dark rounded @click.prevent="filterCompanies">
            <v-icon left>mdi-magnify</v-icon>
            Поиск
          </v-btn>
        </div>
      </div>
      <v-divider class="my-0" />
      <v-data-table
        class="table"
        :headers="headersCompanyGroup"
        :items="managementsGroup"
        :options.sync="options"
        :server-items-length="totalCompaniesGroup"
        :footer-props="{
          'items-per-page-options': [10, 20, 50],
          showFirstLastPage: true,
        }"
      >
        <template v-slot:item.companies="{ item }">
          <div>
            <ul class="pl-0" v-for="(company, index) in item.companies" :key="company.id" v-show="isExpanded(item.id) || index < 5">
              {{ company.name }}
            </ul>
            <div v-if="item.companies.length > 5">
              <v-btn text small color="primary" @click="toggleExpand(item.id)">
                {{ isExpanded(item.id) ? 'Скрыть' : 'Показать еще' }}
              </v-btn>
            </div>
          </div>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-row justify="center" class="flex-nowrap">
            <v-tooltip v-if="$checkPermission('update_management_group')" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  text
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="btn__icon pa-0 mr-1"
                  width="18"
                  height="18"
                  @click.stop="$set(editDialog, item.id, true)"
                >
                  <v-icon size="large">mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Редактировать</span>
            </v-tooltip>
            <v-dialog v-model="editDialog[item.id]" max-width="500" content-class="dialog-border-radius">
              <NewGroupManagementModal
                :active.sync="editDialog[item.id]"
                @close="$set(editDialog, item.id, false)"
                :id="item.id"
                :initial-data="JSON.parse(JSON.stringify(item))"
                @submit="loadManagementGroup()"
              />
            </v-dialog>
            <v-tooltip v-if="$checkPermission('destroy_management_group')" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  text
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="btn__icon pa-0"
                  width="18"
                  height="18"
                  @click.stop="$set(deleteDialog, item.id, true)"
                >
                  <v-icon size="large">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Удалить</span>
            </v-tooltip>
            <v-dialog v-model="deleteDialog[item.id]" width="500" content-class="dialog-border-radius">
              <BaseDeleteModal
                :active.sync="deleteDialog[item.id]"
                @close="$set(deleteDialog, item.id, false)"
                @submit="removeManagementGroup(item.id)"
                messageTitle="Удалить группу?"
                messageText="Подтверждая, вы удалите группу управляющей компании."
              />
            </v-dialog>
          </v-row>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="createDialog" max-width="500" content-class="dialog-border-radius">
      <NewGroupManagementModal
        :active.sync="createDialog"
        @close="createDialog = false"
        @submit="loadManagementGroup()"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseDeleteModal from '@/components/BaseDeleteModal';
import NewGroupManagementModal from '@/components/groupManagementCompany/NewGroupManagementModal';

export default {
  name: 'GroupManagement',
  components: {
    NewGroupManagementModal,
    BaseDeleteModal,
  },
  data () {
    return {
      isCreated: false,
      showAllCompanies: false,
      createDialog: false,
      filterName: '',
      viewDialog: {},
      deleteDialog: {},
      filters: {},
      expandedRows: {},
      attPopupEditContent: {},
      editDialog: {},
      sort: '',
      totalCompaniesGroup: 0,
      options: { itemsPerPage: 20 },
      headersCompanyGroup: [
        { text: 'id', value: 'id' },
        { text: 'Название', value: 'name' },
        { text: 'Адрес', value: 'address', sortable: false },
        { text: 'Контакты', value: 'contacts', sortable: false },
        { text: 'Управляющая компания', value: 'companies' },
        { text: 'Кол-во домофонов', value: 'doorphones_count' },
        { text: '', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters({
      managementsGroup: 'GroupManagementCompany/managementsGroup',
    }),
  },
  methods: {
    ...mapActions({
      getManagementsGroups: 'GroupManagementCompany/getManagementsGroups',
      deleteManagementGroup: 'GroupManagementCompany/deleteManagementGroup',
    }),
    isExpanded (rowId) {
      return !!this.expandedRows[rowId];
    },
    toggleExpand (rowId) {
      this.$set(this.expandedRows, rowId, !this.isExpanded(rowId));
    },
    loadManagementGroup () {
      this.getManagementsGroups({
        pagination: 1,
        page: this.options.page,
        filters: this.filters,
        limit: this.options.itemsPerPage,
        sort: this.sort,
      })
        .then((response) => {
          this.totalCompaniesGroup = response.meta.total;
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке групп управляющих компаний');
        });
    },
    removeManagementGroup (id) {
      this.deleteManagementGroup(id)
        .then(() => {
          this.$flash_success('Группа управляющей компании успешно удалена');
          this.getManagementsGroups();
        })
        .catch(() => {
          this.$flash_warning('Ошибка при удалении группы управляющей компании');
        });
      this.deleteDialog[id] = false;
    },
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterCompanies();
      }
    },
    filterCompanies () {
      this.options.page = 1;
      this.filters = {};

      if (this.filterName) {
        this.filters.name = this.filterName;
      }

      this.loadManagementGroup();
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
    },
  },
  created () {
    this.isCreated = true;
    this.loadManagementGroup();
  },
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.updateSort();
          this.loadManagementGroup();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.group-management-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.group-management-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.group-management-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.group-management-header__btn {
  text-transform: none;
  font-weight: 500;
}

.group-management-block {
  border-radius: 12px;
  overflow: hidden;
}

.group-management-filters {
  padding: 10px 16px 8px;
}

.group-management-filters__title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #546e7a;
  padding: 0 0 6px 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.group-management-filters__row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.group-management-filters__field {
  max-width: 320px;
  width: 100%;
  min-width: 180px;
}

@media screen and (max-width: 600px) {
  .group-management-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .group-management-header__title {
    font-size: 1.4rem;
  }

  .group-management-filters__field {
    max-width: none;
  }
}
</style>
